export default {
  address: {
    list: [],
    headers: [
      {
        label: "Tipo",
        field: "tipo"
      },
      {
        label: "Calle",
        field: "calle"
      },
      {
        label: "Colonia",
        field: "colonia"
      },
      {
        label: "Número exterior",
        field: "noExt"
      },
      {
        label: "C.P.",
        field: "cp"
      },
      {
        label: "Ciudad",
        field: "ciudad"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  stations: {
    list: {},
    select: [],
    headers: [
      {
        label: "#",
        field: "noEstacion"
      },
      {
        label: "Nombre",
        field: "nombre"
      },
      {
        label: "RFC",
        field: "rfc"
      },
      {
        label: "Fecha de alta",
        field: "fecha"
      },
      {
        label: "Fecha de vencimiento",
        field: "fecha"
      },
      {
        label: "Acciones",
        field: ""
      }
    ],
    headersDash: [
      {
        label: "#",
        field: "noEstacion"
      },
      {
        label: "Nombre",
        field: "nombreComercial"
      },
      {
        label: "Nombre comercial",
        field: "nombreComercial"
      },
      {
        label: "Estatus",
        field: "status"
      },
      {
        label: "Fecha de expiración",
        field: "expiration_date"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  tasks: {
    list: [],
    headers: [
      {
        label: "Ruta directorio",
        field: "ruta"
      },
      {
        label: "Fecha inicio",
        field: "fecha"
      },
      {
        label: "Extensión archivo",
        field: "extension"
      },
      {
        label: "Tipo respaldo",
        field: "tipo"
      },
      {
        label: "Periodo",
        field: "periodo"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  configurations: {
    select: [],
    list: [],
    headers: [
      {
        label: "Archivos Respaldados",
        field: "noRespaldos"
      },
      {
        label: "Fecha inicio",
        field: "fecha"
      },
      {
        label: "Activo",
        field: "estatus"
      },
      {
        label: "Nombre Configuración",
        field: "nombre"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  backups: {
    list: [],
    headers: [
      {
        label: "Estación",
        field: "estacion"
      },
      {
        label: "Fecha respaldo",
        field: "fecha"
      },
      {
        label: "Tamaño (Bytes)",
        field: "tamanio"
      },
      {
        label: "Archivo/Descargar",
        field: "archivo"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  users: {
    list: [],
    headers: [
      {
        label: "Usuario",
        field: "usuario"
      },
      {
        label: "Nombre",
        field: "nombre"
      },
      {
        label: "Correo electrónico",
        field: "email"
      },
      {
        label: "Acciones",
        field: ""
      }
    ]
  },
  menu: [
    {
      type: "info",
      icon: "ti-user",
      title: "Usuarios",
      url: "usuarios",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_users",
      name: "Usuarios",
      to: "/usuarios"
    },
    {
      type: "danger",
      icon: "ti-truck",
      title: "Estaciones",
      url: "estaciones",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_stations",
      name: "Estaciones",
      to: "/estaciones"
    },
    {
      type: "warning",
      icon: "ti-book",
      title: "Direcciones",
      url: "direcciones",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_address",
      name: "Direcciones",
      to: "/direcciones"
    },
    {
      type: "warning",
      icon: "ti-settings",
      title: "Genera archivo de configuración",
      url: "generar-archivo-configuracion",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_configurations",
      name: "Configuración",
      to: "/descargar-tareas"
    },
    {
      type: "success",
      icon: "ti-view-list-alt",
      title: "Configura tareas por estación",
      url: "tareas-estacion",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_tasks",
      name: "Tareas",
      to: "/tareas-estacion"
    },
    // {
    //   type: "danger",
    //   icon: "ti-download",
    //   title: "Descarga tareas programadas",
    //   url: "descargar-tareas",
    //   footerText: "Ir",
    //   footerIcon: "ti-angle-right",
    //   rol: "menu_tasks",
    //   name: "Tareas",
    //   to: "/descargar-tareas"
    // },
    {
      type: "info",
      icon: "ti-cloud-down",
      title: "Descarga respaldos generados",
      url: "descargar-respaldo",
      footerText: "Ir",
      footerIcon: "ti-angle-right",
      rol: "menu_backups",
      name: "Respaldos",
      to: "/descargar-respaldo"
    }
  ]
}
